export default "__VITE_ASSET__btknJmzN__";